import { __assign, __awaiter, __generator, __read } from "tslib";
import React, { useState } from "react";
import classNames from "classnames";
import { View } from "../_core/components";
import { Popup } from "../popup";
import { Col, Row } from "../flex";
import { Button } from "../button";
import { noop } from "../_util/noop";
import { modalEmitter } from "./ModalManager";
import { useTranslation } from "../config-provider/i18n";
import { useConfig } from "../_util/use-config";
export function Modal(_a) {
    var _b;
    var visible = _a.visible, onVisibleChange = _a.onVisibleChange, mask = _a.mask, _c = _a.maskClosable, maskClosable = _c === void 0 ? false : _c, destroyOnClose = _a.destroyOnClose, _d = _a.onClose, onClose = _d === void 0 ? noop : _d, title = _a.title, content = _a.content, hideCancel = _a.hideCancel, cancelText = _a.cancelText, confirmText = _a.confirmText, _e = _a.confirmButtonProps, confirmButtonProps = _e === void 0 ? {} : _e, _f = _a.cancelButtonProps, cancelButtonProps = _f === void 0 ? {} : _f, _g = _a.onCancel, onCancel = _g === void 0 ? noop : _g, _h = _a.onConfirm, onConfirm = _h === void 0 ? noop : _h, zIndex = _a.zIndex, 
    // children,
    className = _a.className, style = _a.style;
    var t = useTranslation();
    var classPrefix = useConfig().classPrefix;
    var _j = __read(useState(false), 2), cancelLoading = _j[0], setCancelLoading = _j[1];
    var _k = __read(useState(false), 2), confirmLoading = _k[0], setConfirmLoading = _k[1];
    function handleCancel(event) {
        return __awaiter(this, void 0, void 0, function () {
            var _1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.stopPropagation();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        setCancelLoading(true);
                        return [4 /*yield*/, onCancel()];
                    case 2:
                        _a.sent();
                        setCancelLoading(false);
                        onClose();
                        onVisibleChange(false);
                        return [3 /*break*/, 4];
                    case 3:
                        _1 = _a.sent();
                        setCancelLoading(false);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function handleConfirm(event) {
        return __awaiter(this, void 0, void 0, function () {
            var _2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.stopPropagation();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        setConfirmLoading(true);
                        return [4 /*yield*/, onConfirm()];
                    case 2:
                        _a.sent();
                        setConfirmLoading(false);
                        onClose();
                        onVisibleChange(false);
                        return [3 /*break*/, 4];
                    case 3:
                        _2 = _a.sent();
                        setConfirmLoading(false);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    return (React.createElement(Popup, { position: "center", visible: visible, onVisibleChange: onVisibleChange, onClose: onClose, mask: mask, maskClosable: maskClosable, destroyOnClose: destroyOnClose, zIndex: zIndex, overlay: React.createElement(View, { className: classNames(classPrefix + "-modal", className), style: style, onClick: function (e) { return e.stopPropagation(); } },
            React.createElement(View, { className: classPrefix + "-modal-inner" },
                React.createElement(View, { className: classPrefix + "-modal__header" },
                    React.createElement(View, { className: classPrefix + "-modal__headertitle" }, title)),
                React.createElement(View, { className: classNames(classPrefix + "-modal__body", (_b = {},
                        _b[classPrefix + "-modal__body--no-title"] = !title,
                        _b)) }, content),
                React.createElement(View, { className: classPrefix + "-modal__footer " + classPrefix + "-hairline--top" },
                    React.createElement(Row, { justify: "space-around", gutter: 0 },
                        !hideCancel && (React.createElement(Col, { className: classPrefix + "-modal__footer-item " + classPrefix + "-hairline--right" },
                            React.createElement(Button, __assign({ loading: cancelLoading, disabled: confirmLoading }, cancelButtonProps, { onClick: handleCancel, className: classNames(classPrefix + "-modal__button", classPrefix + "-modal__button--cancel", cancelButtonProps.className) }), cancelText || t.cancelText))),
                        React.createElement(Col, { className: classPrefix + "-modal__footer-item" },
                            React.createElement(Button, __assign({ loading: confirmLoading, disabled: cancelLoading }, confirmButtonProps, { onClick: handleConfirm, className: classNames(classPrefix + "-modal__button", classPrefix + "-modal__button--confirm", confirmButtonProps.className) }), confirmText || t.confirmText)))))) }));
}
Modal.show = function show(options) {
    modalEmitter.emit("show", options);
};
Modal.hide = function hide() {
    modalEmitter.emit("hide");
};
//# sourceMappingURL=Modal.js.map